<template>
    <SpotRatesUpdated>
        <div class="navbar-chart-l d-flex align-items-center w-100 hide-scrollbar">
            <template v-for="(data, metal) in spotRatesStore.spotRates">
                <div
                    v-if="metal !== 'datetime' && metal !== 'rhodium'"
                    :key="metal"
                    class="navbar-chart-li me-lg-5"
                >
                    <NuxtLink
                        :to="localePath({
                          name: 'charts-code',
                          params: { code: $t('url.' + metal + '-price') }
                        })"
                        class="price-link pe-2 text-nowrap"
                    >
                        <span class="metal-name">
                          <b>{{ $t(data.oz.raw_name) }}</b>
                        </span>

                        <span class="price">
                          &nbsp;&nbsp;{{ $formatter.price(data.oz.price || 0) }}
                        </span>
                        <span v-if="data.oz.diff" class="percent">
                          &nbsp;&nbsp;({{ $formatter.percent(Math.abs(data.oz.percent || 0)) }}%)
                        </span>
                    </NuxtLink>
                    <span :class="'navbar-chart-' + (data.oz.icon || 'none')">&nbsp;</span>
                </div>
            </template>
        </div>
    </SpotRatesUpdated>
</template>

<script setup>
import { useLocalePath } from '#imports'
import { useSpotRatesStore } from '~/stores/SpotRatesStore'
const SpotRatesUpdated = defineAsyncComponent(() => import("~/components/SpotRatesUpdated.vue"));

const spotRatesStore = useSpotRatesStore()
const localePath = useLocalePath()
</script>
